module.exports = __webpack_public_path__ + "static/media/mogulreitii.d8a938c6.m4v";